import {createTextVariant} from './Text.js'

export default createTextVariant('h1', 'H1')
